export const UMA_GET_MODEL_DIRTY_2 = {
	success: true,
	errors: [{
		code: 'MODEL_IS_OVERRIDDEN_AT_BLK',
		message: 'The model is imported in BLK',
		details: 'no'
	},
	{
		code: 'MODEL_IS_MODIFIED_AT_SOURCE',
		message: 'The model has been modified at source since its last import',
		details: 'no'
	},
	{
		code: 'MODEL_IS_A_FIRST_TIME_IMPORT',
		message: 'The model is imported for first time ',
		details: 'no'
	}],
	status: 'OK',
	response: {
		id: 'ba38c5fc-0fa4-41d4-a7a2-1f5af20e8a20',
		description: 'UMA BLK Test New Model 1',
		type: 'PORTFOLIO',
		subType: 'THIRD_PARTY_MODEL',
		children: [{
			identifier: 'ba38c5fc-0fa4-41d4-a7a2-1f5af20e8a20',
			identifierType: 'CUSTOM',
			weight: 15.0,
			portfolio: {
				id: 'ba38c5fc-0fa4-41d4-a7a2-1f5af20e8a20',
				description: 'UMA BLK AJ1 Sleeve Model',
				type: 'PORTFOLIO',
				subType: 'THIRD_PARTY_MODEL',
				children: [{
					identifier: 'GOOG@02079K107@US02079K1079',
					identifierType: 'SECURITY_ID',
					weight: 30.0,
					allData: {
						date: 1588668049796,
						positionType: 'VALID',
						'@type': '_bws.user.WebUserData',
						identifierType: 'SECURITY_ID',
						type: 'PORTFOLIO_POSITION',
						currentUserIsOwner: true,
						score: 1,
						dateCreated: 1588668049796,
						dateLastModified: 1588668049796,
						userEmail: 'ssangeet+123@bfm.com',
						commonIdentifier: 'GOOG@02079K107@US02079K1079',
						owner: {
							userPlatformId: '4279682',
							userEmail: 'ssangeet+123@bfm.com',
							userId: 'ssangeet+123@bfm.com'
						},
						identifier: 'GOOG@02079K107@US02079K1079',
						trackingType: 'userData',
						userPlatformId: '4279682',
						childFlag: true,
						level: 1,
						updateUserId: 'ssangeet+123@bfm.com',
						weight: 30,
						userId: 'ssangeet+123@bfm.com',
						updateTimestamp: 1588668049801,
						parentId: 'ba38c5fc-0fa4-41d4-a7a2-1f5af20e8a20',
						parentType: 'PORTFOLIO',
						commonIdentifierType: 'SECURITY_ID',
						otherIdentifiers: [{
							identifier: '02079K107',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						},
						{
							identifier: '0100000EOOP0111262196HALRLCGAKIKCDGTJB7XPGCQL5ZOBRGZOYYUCEH5GIJG5V27MZETLQ====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'GOOG',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						}],
						originPlatform: {
							name: 'Alphabet Inc C',
							type: 'SECURITY'
						},
						userTrackingId: '2620693',
						uniqueId: '455e5268-54df-4f46-b1ca-2d9cc940e72d'
					}
				},
				{
					identifier: 'AGG@464287226@US4642872265',
					identifierType: 'SECURITY_ID',
					weight: 30.0,
					allData: {
						date: 1588668049796,
						positionType: 'VALID',
						'@type': '_bws.user.WebUserData',
						identifierType: 'SECURITY_ID',
						type: 'PORTFOLIO_POSITION',
						currentUserIsOwner: true,
						score: 1,
						dateCreated: 1588668049796,
						dateLastModified: 1588668049796,
						userEmail: 'ssangeet+123@bfm.com',
						commonIdentifier: 'AGG@464287226@US4642872265',
						owner: {
							userPlatformId: '4279682',
							userEmail: 'ssangeet+123@bfm.com',
							userId: 'ssangeet+123@bfm.com'
						},
						identifier: 'AGG@464287226@US4642872265',
						trackingType: 'userData',
						userPlatformId: '4279682',
						childFlag: true,
						level: 1,
						updateUserId: 'ssangeet+123@bfm.com',
						weight: 30,
						userId: 'ssangeet+123@bfm.com',
						updateTimestamp: 1588668049801,
						parentId: 'ba38c5fc-0fa4-41d4-a7a2-1f5af20e8a20',
						parentType: 'PORTFOLIO',
						commonIdentifierType: 'SECURITY_ID',
						otherIdentifiers: [{
							identifier: '0100000EOOP01114905HLOSJKO4FOOCQVJNCXQQKXFIZQUMDEYRADOFKSBH7USR3A6NVJATA====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'AGG',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: '464287226',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						}],
						originPlatform: {
							name: 'iShares Core US Aggregate Bond',
							type: 'SECURITY'
						},
						userTrackingId: '2620693',
						uniqueId: '6c01a984-46a1-4b6a-8265-f7501aac0976'
					}
				},
				{
					identifier: 'IJR@464287804@US4642878049',
					identifierType: 'SECURITY_ID',
					weight: 40.0,
					allData: {
						date: 1588668049796,
						positionType: 'VALID',
						'@type': '_bws.user.WebUserData',
						identifierType: 'SECURITY_ID',
						type: 'PORTFOLIO_POSITION',
						currentUserIsOwner: true,
						score: 1,
						dateCreated: 1588668049796,
						dateLastModified: 1588668049796,
						userEmail: 'ssangeet+123@bfm.com',
						commonIdentifier: 'IJR@464287804@US4642878049',
						owner: {
							userPlatformId: '4279682',
							userEmail: 'ssangeet+123@bfm.com',
							userId: 'ssangeet+123@bfm.com'
						},
						identifier: 'IJR@464287804@US4642878049',
						trackingType: 'userData',
						userPlatformId: '4279682',
						childFlag: true,
						level: 1,
						updateUserId: 'ssangeet+123@bfm.com',
						weight: 40,
						userId: 'ssangeet+123@bfm.com',
						updateTimestamp: 1588668049801,
						parentId: 'ba38c5fc-0fa4-41d4-a7a2-1f5af20e8a20',
						parentType: 'PORTFOLIO',
						commonIdentifierType: 'SECURITY_ID',
						otherIdentifiers: [{
							identifier: '464287804',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						},
						{
							identifier: '0100000EOOP0115899HVBI3IP22J7H4T2VCCUDLS5OFN3SZP3CJFU4IF4NPCWSZBO4KSN7Q====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'IJR',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						}],
						originPlatform: {
							name: 'iShares Core S&P Small-Cap',
							type: 'SECURITY'
						},
						userTrackingId: '2620693',
						uniqueId: '76cac0ec-c683-4a31-9964-4533535adba0'
					}
				}],
				allData: {
					date: 1588668049796,
					'@type': 'com.bfm.webtools.api.domain.user.WebUserData',
					origin: 'partner',
					flags: {
						originContainsEditableModel: true,
						originContainsReallocatedSecurities: false,
						inputWithValues: false,
						originContainsFlattenedSleeves: false,
						isProcessed: false,
						originContainsUnmatchedSecurities: false
					},
					description: 'UMA BLK AJ1 Sleeve Model',
					type: 'PORTFOLIO',
					currentUserIsOwner: true,
					score: 1,
					parentFlag: true,
					dateCreated: 1588668049796,
					dateLastModified: 1588668049796,
					userEmail: 'ssangeet+123@bfm.com',
					perms: {
						DELETE: ['webUserDataPerm@AdvisorPort'],
						SHARE: ['webUserDataPerm@AdvisorPort'],
						VIEW: ['webUserDataPerm@AdvisorPort']
					},
					owner: {
						userPlatformId: '4279682',
						userEmail: 'ssangeet+123@bfm.com',
						userId: 'ssangeet+123@bfm.com'
					},
					ssoIdp: 'envestnet',
					toolOrigin: 'partner',
					trackingType: 'userData',
					userPlatformId: '4279682',
					level: 0,
					updateUserId: 'ssangeet+123@bfm.com',
					childCount: 3,
					userId: 'ssangeet+123@bfm.com',
					updateTimestamp: 1588668049802,
					otherIdentifiers: [{
						identifier: '0100000EEEN015591284H6QT3XORNQY5XWZEJ3NUTZKVF52QPD6PYTOLZP27RCPIQLQN6QQ6A====',
						customIdentifierType: 'ENVESTNET_HANDLE',
						'@type': '_bws.investments.IdentifierParam',
						identifierType: 'CUSTOM'
					}],
					subType: 'THIRD_PARTY_MODEL',
					originPlatform: {
						firm: 'BLK Demo',
						dateImported: '1588668049750',
						programHandle: '0100000EEEN01613HTERU5ACK7K7LVH4SCFH27PYMT7DJGMUVG3XAIJDRRANTIEIPDECA====',
						externalModelDateLastModified: '1588056447687',
						riskHandle: '0100000EOOP03319HHDGRBCT6R5HKSEOM7SVAPCF42QESC7I5246T3UHHCE5X5YGWBATQ====',
						platform: 'ENVESTNET'
					},
					userTrackingId: '2620693',
					uniqueId: 'ba38c5fc-0fa4-41d4-a7a2-1f5af20e8a20',
					applications: ['partner',
						'bfa']
				}
			},
			allData: {
				date: 1588762612132,
				positionType: 'VALID',
				'@type': '_bws.user.WebUserData',
				identifierType: 'CUSTOM',
				type: 'PORTFOLIO_POSITION',
				currentUserIsOwner: true,
				score: 1,
				dateCreated: 1588762612132,
				dateLastModified: 1588762612132,
				userEmail: 'ssangeet+123@bfm.com',
				owner: {
					userPlatformId: '4279682',
					userEmail: 'ssangeet+123@bfm.com',
					userId: 'ssangeet+123@bfm.com'
				},
				identifier: 'ba38c5fc-0fa4-41d4-a7a2-1f5af20e8a20',
				trackingType: 'userData',
				userPlatformId: '4279682',
				childFlag: true,
				level: 1,
				updateUserId: 'ssangeet+123@bfm.com',
				weight: 15,
				userId: 'ssangeet+123@bfm.com',
				updateTimestamp: 1588762612430,
				parentId: 'a87c21cb-3e7f-47af-9067-274cdb951475',
				parentType: 'PORTFOLIO',
				otherIdentifiers: [{
					identifier: 'AS-22803',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'TICKER'
				},
				{
					identifier: '0100000EOOP0116030486HKDDZXCDR65ZIZA237IMB555YQBHAN6LW26RONXLLDA6FDZASBPJQ====',
					customIdentifierType: 'ENVESTNET_HANDLE',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'CUSTOM'
				}],
				originPlatform: {
					name: 'Advisor Sleeve Model',
					type: 'APM_SLEEVE'
				},
				userTrackingId: '2620693',
				uniqueId: '146b18ce-b97e-4ddb-a838-d7a842f2e39f'
			}
		},
		{
			identifier: '922d8727-4336-4bb9-82f0-8e27bc1eec3a',
			identifierType: 'CUSTOM',
			weight: 10.0,
			portfolio: {
				id: '922d8727-4336-4bb9-82f0-8e27bc1eec3a',
				description: 'BLK AJ2 Sleeve',
				type: 'PORTFOLIO',
				subType: 'THIRD_PARTY_MODEL',
				children: [{
					identifier: 'ENVESTNET_HANDLE@0100000EOOP01114516HLOSJKO4FOOCQVJNCXQQKXFIZQVAMRDZZPKXDHGEOWZ7OVSKLD5OQ====',
					identifierType: 'CUSTOM',
					weight: 20.0,
					allData: {
						date: 1588762571151,
						positionType: 'INVALID',
						'@type': '_bws.user.WebUserData',
						identifierType: 'CUSTOM',
						type: 'PORTFOLIO_POSITION',
						currentUserIsOwner: true,
						score: 1,
						dateCreated: 1588762571151,
						dateLastModified: 1588762571151,
						userEmail: 'ssangeet+123@bfm.com',
						owner: {
							userPlatformId: '4279682',
							userEmail: 'ssangeet+123@bfm.com',
							userId: 'ssangeet+123@bfm.com'
						},
						identifier: 'ENVESTNET_HANDLE@0100000EOOP01114516HLOSJKO4FOOCQVJNCXQQKXFIZQVAMRDZZPKXDHGEOWZ7OVSKLD5OQ====',
						trackingType: 'userData',
						userPlatformId: '4279682',
						childFlag: true,
						level: 1,
						updateUserId: 'ssangeet+123@bfm.com',
						weight: 20,
						userId: 'ssangeet+123@bfm.com',
						updateTimestamp: 1588762571287,
						parentId: '922d8727-4336-4bb9-82f0-8e27bc1eec3a',
						parentType: 'PORTFOLIO',
						otherIdentifiers: [{
							identifier: '464287176',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						},
						{
							identifier: 'TIP',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: '0100000EOOP01114516HLOSJKO4FOOCQVJNCXQQKXFIZQVAMRDZZPKXDHGEOWZ7OVSKLD5OQ====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						}],
						originPlatform: {
							name: 'iShares TIPS Bond',
							type: 'SECURITY'
						},
						userTrackingId: '2620693',
						uniqueId: '526a9f3f-9b2d-4979-8d87-bfa0af70c37d'
					}
				},
				{
					identifier: 'ENVESTNET_HANDLE@0100000EOOP01112384HALRLCGAKIKCDGTJB7XPGCQL5ZORZMN2EQCMAA32MZVFA7F4BGKMQ====',
					identifierType: 'CUSTOM',
					weight: 40.0,
					allData: {
						date: 1588762571151,
						positionType: 'INVALID',
						'@type': '_bws.user.WebUserData',
						identifierType: 'CUSTOM',
						type: 'PORTFOLIO_POSITION',
						currentUserIsOwner: true,
						score: 1,
						dateCreated: 1588762571151,
						dateLastModified: 1588762571151,
						userEmail: 'ssangeet+123@bfm.com',
						owner: {
							userPlatformId: '4279682',
							userEmail: 'ssangeet+123@bfm.com',
							userId: 'ssangeet+123@bfm.com'
						},
						identifier: 'ENVESTNET_HANDLE@0100000EOOP01112384HALRLCGAKIKCDGTJB7XPGCQL5ZORZMN2EQCMAA32MZVFA7F4BGKMQ====',
						trackingType: 'userData',
						userPlatformId: '4279682',
						childFlag: true,
						level: 1,
						updateUserId: 'ssangeet+123@bfm.com',
						weight: 40,
						userId: 'ssangeet+123@bfm.com',
						updateTimestamp: 1588762571287,
						parentId: '922d8727-4336-4bb9-82f0-8e27bc1eec3a',
						parentType: 'PORTFOLIO',
						otherIdentifiers: [{
							identifier: 'IVV',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: '464287200',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						},
						{
							identifier: '0100000EOOP01112384HALRLCGAKIKCDGTJB7XPGCQL5ZORZMN2EQCMAA32MZVFA7F4BGKMQ====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						}],
						originPlatform: {
							name: 'iShares Core S&P 500',
							type: 'SECURITY'
						},
						userTrackingId: '2620693',
						uniqueId: 'd2842e14-d3eb-479b-9408-c6ebfaa61aba'
					}
				},
				{
					identifier: 'ENVESTNET_HANDLE@0100000EOOP01167123HUBLAGQT2QYTILUXGY4JAO6LDL4L6TIPLGQBB4IR735GAF63HPBOQ====',
					identifierType: 'CUSTOM',
					weight: 40.0,
					allData: {
						date: 1588762571151,
						positionType: 'INVALID',
						'@type': '_bws.user.WebUserData',
						identifierType: 'CUSTOM',
						type: 'PORTFOLIO_POSITION',
						currentUserIsOwner: true,
						score: 1,
						dateCreated: 1588762571151,
						dateLastModified: 1588762571151,
						userEmail: 'ssangeet+123@bfm.com',
						owner: {
							userPlatformId: '4279682',
							userEmail: 'ssangeet+123@bfm.com',
							userId: 'ssangeet+123@bfm.com'
						},
						identifier: 'ENVESTNET_HANDLE@0100000EOOP01167123HUBLAGQT2QYTILUXGY4JAO6LDL4L6TIPLGQBB4IR735GAF63HPBOQ====',
						trackingType: 'userData',
						userPlatformId: '4279682',
						childFlag: true,
						level: 1,
						updateUserId: 'ssangeet+123@bfm.com',
						weight: 40,
						userId: 'ssangeet+123@bfm.com',
						updateTimestamp: 1588762571287,
						parentId: '922d8727-4336-4bb9-82f0-8e27bc1eec3a',
						parentType: 'PORTFOLIO',
						otherIdentifiers: [{
							identifier: '09251T509',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						},
						{
							identifier: 'MALOX',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: '0100000EOOP01167123HUBLAGQT2QYTILUXGY4JAO6LDL4L6TIPLGQBB4IR735GAF63HPBOQ====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						}],
						originPlatform: {
							name: 'BlackRock Global Allocation Instl',
							type: 'SECURITY'
						},
						userTrackingId: '2620693',
						uniqueId: 'fd6198a1-aeda-4751-9880-b6bea58f7b29'
					}
				}],
				allData: {
					date: 1588762571151,
					'@type': 'com.bfm.webtools.api.domain.user.WebUserData',
					origin: 'partner',
					flags: {
						originContainsEditableModel: true,
						firstTimeImport: true,
						inputWithValues: false,
						isProcessed: false,
						originContainsUnmatchedSecurities: true,
						originContainsSleeves: false
					},
					description: 'BLK AJ2 Sleeve',
					type: 'PORTFOLIO',
					currentUserIsOwner: true,
					score: 1,
					parentFlag: true,
					dateCreated: 1588762571151,
					dateLastModified: 1588762571151,
					userEmail: 'ssangeet+123@bfm.com',
					perms: {
						DELETE: ['webUserDataPerm@AdvisorPort'],
						SHARE: ['webUserDataPerm@AdvisorPort'],
						VIEW: ['webUserDataPerm@AdvisorPort']
					},
					owner: {
						userPlatformId: '4279682',
						userEmail: 'ssangeet+123@bfm.com',
						userId: 'ssangeet+123@bfm.com'
					},
					ssoIdp: 'envestnet',
					toolOrigin: 'partner',
					trackingType: 'userData',
					userPlatformId: '4279682',
					level: 0,
					updateUserId: 'ssangeet+123@bfm.com',
					childCount: 3,
					userId: 'ssangeet+123@bfm.com',
					updateTimestamp: 1588762571288,
					otherIdentifiers: [{
						identifier: '0100000EEEN015591285H6QT3XORNQY5XWZEJ3NUTZKVF5ZCQ73EGMG3BGBVLOPCF5HAMV5CA====',
						customIdentifierType: 'ENVESTNET_HANDLE',
						'@type': '_bws.investments.IdentifierParam',
						identifierType: 'CUSTOM'
					}],
					subType: 'THIRD_PARTY_MODEL',
					originPlatform: {
						firm: 'BLK Demo',
						dateImported: '1588762571118',
						programHandle: '0100000EEEN01613HTERU5ACK7K7LVH4SCFH27PYMT7DJGMUVG3XAIJDRRANTIEIPDECA====',
						portfolioType: 'ADVISOR_MODEL',
						externalModelDateLastModified: '1588056732073',
						riskHandle: '0100000EOOP03322HEV56HLYLXI7XIDZHGMC66QM2ZQ6RXCZJWL76P4N4I2JIAZJOJKFA====',
						platform: 'ENVESTNET'
					},
					userTrackingId: '2620693',
					uniqueId: '922d8727-4336-4bb9-82f0-8e27bc1eec3a',
					applications: ['partner',
						'bfa']
				}
			},
			allData: {
				date: 1588762612132,
				positionType: 'VALID',
				'@type': '_bws.user.WebUserData',
				identifierType: 'CUSTOM',
				type: 'PORTFOLIO_POSITION',
				currentUserIsOwner: true,
				score: 1,
				dateCreated: 1588762612132,
				dateLastModified: 1588762612132,
				userEmail: 'ssangeet+123@bfm.com',
				owner: {
					userPlatformId: '4279682',
					userEmail: 'ssangeet+123@bfm.com',
					userId: 'ssangeet+123@bfm.com'
				},
				identifier: '922d8727-4336-4bb9-82f0-8e27bc1eec3a',
				trackingType: 'userData',
				userPlatformId: '4279682',
				childFlag: true,
				level: 1,
				updateUserId: 'ssangeet+123@bfm.com',
				weight: 10,
				userId: 'ssangeet+123@bfm.com',
				updateTimestamp: 1588762612430,
				parentId: 'a87c21cb-3e7f-47af-9067-274cdb951475',
				parentType: 'PORTFOLIO',
				otherIdentifiers: [{
					identifier: '0100000EOOP0116030487HKDDZXCDR65ZIZA237IMB555YQAGFEX6GUMALHIPJJES6X27AFVPQ====',
					customIdentifierType: 'ENVESTNET_HANDLE',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'CUSTOM'
				},
				{
					identifier: 'AS-22804',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'TICKER'
				}],
				originPlatform: {
					name: 'Advisor Sleeve Model',
					type: 'APM_SLEEVE'
				},
				userTrackingId: '2620693',
				uniqueId: '29e4714b-d264-4be8-a820-3fc9eb2a83fe'
			}
		},
		{
			identifier: 'ENVESTNET_HANDLE@0100000EOOP0112502381H3X4RWBBRKMBRACQMWOD47JEON5UAKPLM2H2ALD7P6D5VTNQAB2OQ====',
			identifierType: 'CUSTOM',
			weight: 5.0,
			allData: {
				date: 1588762612132,
				positionType: 'INVALID',
				'@type': '_bws.user.WebUserData',
				identifierType: 'CUSTOM',
				type: 'PORTFOLIO_POSITION',
				currentUserIsOwner: true,
				score: 1,
				dateCreated: 1588762612132,
				dateLastModified: 1588762612132,
				userEmail: 'ssangeet+123@bfm.com',
				owner: {
					userPlatformId: '4279682',
					userEmail: 'ssangeet+123@bfm.com',
					userId: 'ssangeet+123@bfm.com'
				},
				identifier: 'ENVESTNET_HANDLE@0100000EOOP0112502381H3X4RWBBRKMBRACQMWOD47JEON5UAKPLM2H2ALD7P6D5VTNQAB2OQ====',
				trackingType: 'userData',
				userPlatformId: '4279682',
				childFlag: true,
				level: 1,
				updateUserId: 'ssangeet+123@bfm.com',
				weight: 5,
				userId: 'ssangeet+123@bfm.com',
				updateTimestamp: 1588762612430,
				parentId: 'a87c21cb-3e7f-47af-9067-274cdb951475',
				parentType: 'PORTFOLIO',
				otherIdentifiers: [{
					identifier: 'ESG',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'TICKER'
				},
				{
					identifier: '0100000EOOP0112502381H3X4RWBBRKMBRACQMWOD47JEON5UAKPLM2H2ALD7P6D5VTNQAB2OQ====',
					customIdentifierType: 'ENVESTNET_HANDLE',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'CUSTOM'
				},
				{
					identifier: '33939L696',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'CUSIP'
				}],
				originPlatform: {
					name: 'FlexShares STOXX US ESG Impact ETF',
					type: 'SECURITY'
				},
				userTrackingId: '2620693',
				uniqueId: '43ecc04c-9482-4b79-bf24-b1993f5a91b7'
			}
		},
		{
			identifier: '270892',
			identifierType: 'MODEL_ID',
			weight: 10.0,
			allData: {
				date: 1588762612132,
				positionType: 'VALID',
				'@type': '_bws.user.WebUserData',
				identifierType: 'MODEL_ID',
				type: 'PORTFOLIO_POSITION',
				currentUserIsOwner: true,
				score: 1,
				dateCreated: 1588762612132,
				dateLastModified: 1588762612132,
				userEmail: 'ssangeet+123@bfm.com',
				owner: {
					userPlatformId: '4279682',
					userEmail: 'ssangeet+123@bfm.com',
					userId: 'ssangeet+123@bfm.com'
				},
				identifier: '270892',
				trackingType: 'userData',
				userPlatformId: '4279682',
				childFlag: true,
				level: 1,
				updateUserId: 'ssangeet+123@bfm.com',
				weight: 10,
				userId: 'ssangeet+123@bfm.com',
				updateTimestamp: 1588762612430,
				parentId: 'a87c21cb-3e7f-47af-9067-274cdb951475',
				parentType: 'PORTFOLIO',
				otherIdentifiers: [{
					identifier: 'FSP41776',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'TICKER'
				},
				{
					identifier: '0100000EOOP0111636417HQ3AT33HE2XPXRNKDXJ2D4K7NXSOWLGWX5JL6YQ4IXSH5VFZXU7RA====',
					customIdentifierType: 'ENVESTNET_HANDLE',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'CUSTOM'
				}],
				originPlatform: {
					name: 'BlackRock 10/90 Target Allocation ETF Portfolio.',
					type: 'MANAGED_MODEL'
				},
				userTrackingId: '2620693',
				uniqueId: '44dbbed8-e7d0-4ab5-bdd8-dd230c903b67'
			}
		},
		{
			identifier: 'ENVESTNET_HANDLE@0100000EOOP011664167HXAMUNSQNEKBHNIPPPSW5HOHOVT5IZZ5NA24MZGPYIKP7TO7XI4PQ====',
			identifierType: 'CUSTOM',
			weight: 5.0,
			allData: {
				date: 1588762612132,
				positionType: 'INVALID',
				'@type': '_bws.user.WebUserData',
				identifierType: 'CUSTOM',
				type: 'PORTFOLIO_POSITION',
				currentUserIsOwner: true,
				score: 1,
				dateCreated: 1588762612132,
				dateLastModified: 1588762612132,
				userEmail: 'ssangeet+123@bfm.com',
				owner: {
					userPlatformId: '4279682',
					userEmail: 'ssangeet+123@bfm.com',
					userId: 'ssangeet+123@bfm.com'
				},
				identifier: 'ENVESTNET_HANDLE@0100000EOOP011664167HXAMUNSQNEKBHNIPPPSW5HOHOVT5IZZ5NA24MZGPYIKP7TO7XI4PQ====',
				trackingType: 'userData',
				userPlatformId: '4279682',
				childFlag: true,
				level: 1,
				updateUserId: 'ssangeet+123@bfm.com',
				weight: 5,
				userId: 'ssangeet+123@bfm.com',
				updateTimestamp: 1588762612430,
				parentId: 'a87c21cb-3e7f-47af-9067-274cdb951475',
				parentType: 'PORTFOLIO',
				otherIdentifiers: [{
					identifier: '0100000EOOP011664167HXAMUNSQNEKBHNIPPPSW5HOHOVT5IZZ5NA24MZGPYIKP7TO7XI4PQ====',
					customIdentifierType: 'ENVESTNET_HANDLE',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'CUSTOM'
				},
				{
					identifier: 'BOND',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'TICKER'
				},
				{
					identifier: '72201R775',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'CUSIP'
				}],
				originPlatform: {
					name: 'PIMCO Active Bond ETF',
					type: 'SECURITY'
				},
				userTrackingId: '2620693',
				uniqueId: 'ab33b087-b3e8-405a-8097-d6bae257491c'
			}
		},
		{
			identifier: 'CASH-USD@XUSD00000@',
			identifierType: 'SECURITY_ID',
			weight: 50.0,
			allData: {
				date: 1588762612132,
				positionType: 'VALID',
				'@type': '_bws.user.WebUserData',
				identifierType: 'SECURITY_ID',
				type: 'PORTFOLIO_POSITION',
				currentUserIsOwner: true,
				score: 1,
				dateCreated: 1588762612132,
				dateLastModified: 1588762612132,
				userEmail: 'ssangeet+123@bfm.com',
				commonIdentifier: 'CASH-USD@XUSD00000@',
				owner: {
					userPlatformId: '4279682',
					userEmail: 'ssangeet+123@bfm.com',
					userId: 'ssangeet+123@bfm.com'
				},
				identifier: 'CASH-USD@XUSD00000@',
				trackingType: 'userData',
				userPlatformId: '4279682',
				childFlag: true,
				level: 1,
				updateUserId: 'ssangeet+123@bfm.com',
				weight: 50,
				userId: 'ssangeet+123@bfm.com',
				updateTimestamp: 1588762612429,
				parentId: 'a87c21cb-3e7f-47af-9067-274cdb951475',
				parentType: 'PORTFOLIO',
				commonIdentifierType: 'SECURITY_ID',
				otherIdentifiers: [{
					identifier: '0100000EOOP01154570HDJVOR3B324GYREVXOV43K3O5475D4Q2LGBQ3HJO7C4B2KE56YTSQ====',
					customIdentifierType: 'ENVESTNET_HANDLE',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'CUSTOM'
				},
				{
					identifier: 'CASH-USD',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'TICKER'
				},
				{
					identifier: 'CASH-USD',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'CUSIP'
				}],
				originPlatform: {
					name: 'Cash',
					type: 'ASSET_CLASS'
				},
				userTrackingId: '2620693',
				uniqueId: '035c8b75-da01-4a8c-aed0-6f8f556fa17c'
			}
		},
		{
			identifier: 'ENVESTNET_HANDLE@0100000EOOP0112167HALM6U3PUEKFOSLBVCYWCYKG2H6FLQFNNBWYX4Q4XQ5QXND4DP5NA====',
			identifierType: 'CUSTOM',
			weight: 5.0,
			allData: {
				date: 1588762612132,
				positionType: 'INVALID',
				'@type': '_bws.user.WebUserData',
				identifierType: 'CUSTOM',
				type: 'PORTFOLIO_POSITION',
				currentUserIsOwner: true,
				score: 1,
				dateCreated: 1588762612132,
				dateLastModified: 1588762612132,
				userEmail: 'ssangeet+123@bfm.com',
				owner: {
					userPlatformId: '4279682',
					userEmail: 'ssangeet+123@bfm.com',
					userId: 'ssangeet+123@bfm.com'
				},
				identifier: 'ENVESTNET_HANDLE@0100000EOOP0112167HALM6U3PUEKFOSLBVCYWCYKG2H6FLQFNNBWYX4Q4XQ5QXND4DP5NA====',
				trackingType: 'userData',
				userPlatformId: '4279682',
				childFlag: true,
				level: 1,
				updateUserId: 'ssangeet+123@bfm.com',
				weight: 5,
				userId: 'ssangeet+123@bfm.com',
				updateTimestamp: 1588762612429,
				parentId: 'a87c21cb-3e7f-47af-9067-274cdb951475',
				parentType: 'PORTFOLIO',
				otherIdentifiers: [{
					identifier: 'SPY',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'TICKER'
				},
				{
					identifier: '0100000EOOP0112167HALM6U3PUEKFOSLBVCYWCYKG2H6FLQFNNBWYX4Q4XQ5QXND4DP5NA====',
					customIdentifierType: 'ENVESTNET_HANDLE',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'CUSTOM'
				},
				{
					identifier: '78462F103',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'CUSIP'
				}],
				originPlatform: {
					name: 'SPDRÂ® S&P 500 ETF',
					type: 'SECURITY'
				},
				userTrackingId: '2620693',
				uniqueId: 'f68426ab-1f37-4acd-be95-50255a6223fe'
			}
		}],
		allData: {
			date: 1588762038723,
			'@type': 'com.bfm.webtools.api.domain.user.WebUserData',
			origin: 'partner',
			flags: {
				originContainsEditableModel: true,
				originContainsReallocatedSecurities: false,
				firstTimeImport: false,
				inputWithValues: false,
				originContainsFlattenedSleeves: true,
				isProcessed: false,
				originContainsUnmatchedSecurities: true,
				originContainsSleeves: true
			},
			description: 'UMA BLK Test New Model 1',
			type: 'PORTFOLIO',
			currentUserIsOwner: true,
			score: 1,
			parentFlag: true,
			dateCreated: 1588762038723,
			dateLastModified: 1588762612132,
			userEmail: 'ssangeet+123@bfm.com',
			perms: {
				DELETE: ['webUserDataPerm@AdvisorPort'],
				SHARE: ['webUserDataPerm@AdvisorPort'],
				VIEW: ['webUserDataPerm@AdvisorPort']
			},
			owner: {
				userPlatformId: '4279682',
				userEmail: 'ssangeet+123@bfm.com',
				userId: 'ssangeet+123@bfm.com'
			},
			ssoIdp: 'envestnet',
			toolOrigin: 'partner',
			trackingType: 'userData',
			userPlatformId: '4279682',
			level: 0,
			updateUserId: 'ssangeet+123@bfm.com',
			childCount: 7,
			userId: 'ssangeet+123@bfm.com',
			updateTimestamp: 1588762612430,
			otherIdentifiers: [{
				identifier: 'ba38c5fc-0fa4-41d4-a7a2-1f5af20e8a20',
				customIdentifierType: 'ENVESTNET_HANDLE',
				'@type': '_bws.investments.IdentifierParam',
				identifierType: 'CUSTOM'
			}],
			subType: 'THIRD_PARTY_MODEL',
			originPlatform: {
				firm: 'BLK Demo',
				dateImported: '1588762038694',
				programHandle: '0100000EEEN016101HZQVGFY3JEUTRWUITOUFKS5LK3L2B4SZ5K5XFE4IXWOCUQK2YSQKQ====',
				portfolioType: 'UNIFIED_MANAGED_ACCOUNT',
				externalModelDateLastModified: '1588057320467',
				riskHandle: '0100000EOOP03319HHDGRBCT6R5HKSEOM7SVAPCF42QESC7I5246T3UHHCE5X5YGWBATQ====',
				platform: 'ENVESTNET'
			},
			userTrackingId: '2620693',
			uniqueId: 'a87c21cb-3e7f-47af-9067-274cdb951475',
			applications: ['partner', 'bfa']
		}
	},
	responseTimes: {
		root: {
			nodes: [{
				data: { getModelDetails: 0.955 },
				nodes: [{ data: { accessToken: 0.0 } },
				{
					data: { searchPortfolio: 0.071 },
					nodes: [{ data: { searchPortfolio: 0.071 } }]
				},
				{
					data: { getPortfolioJson: 0.161 },
					nodes: [{
						data: { getPortfolioJson: 0.115 },
						nodes: [{ data: { getPortfolioJson: 0.074 } }]
					}]
				}]
			}]
		}
	}
};
